import type { ChatMessage } from '@/stores/useAiAssistantStore';

export type ProjectCreateUserRefPayload = {
  fieldLabel: string;
  quoted: string;
  requirement: string;
};

export type ProjectCreateFieldEditPayload = {
  fieldPath: string;
  original: string;
  revised: string;
  status: 'pending' | 'accepted' | 'rejected';
};

export function getProjectCreateUserRefFromMessage(msg: ChatMessage): ProjectCreateUserRefPayload | null {
  const sr = msg.structuredResult;
  if (!sr || typeof sr !== 'object') return null;
  const raw = (sr as Record<string, unknown>).project_create_user_ref;
  if (!raw || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  const fieldLabel = typeof o.fieldLabel === 'string' ? o.fieldLabel : '';
  const quoted = typeof o.quoted === 'string' ? o.quoted : '';
  const requirement = typeof o.requirement === 'string' ? o.requirement : '';
  if (!fieldLabel || !quoted) return null;
  return { fieldLabel, quoted, requirement };
}

export function getProjectCreateFieldEditFromMessage(msg: ChatMessage): ProjectCreateFieldEditPayload | null {
  const sr = msg.structuredResult;
  if (!sr || typeof sr !== 'object') return null;
  const raw = (sr as Record<string, unknown>).project_create_field_edit;
  if (!raw || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  const fieldPath = typeof o.fieldPath === 'string' ? o.fieldPath : '';
  const original = typeof o.original === 'string' ? o.original : '';
  const revised = typeof o.revised === 'string' ? o.revised : '';
  const st = o.status;
  const status: ProjectCreateFieldEditPayload['status'] =
    st === 'accepted' || st === 'rejected' || st === 'pending' ? st : 'pending';
  if (!fieldPath) return null;
  return { fieldPath, original, revised, status };
}

export function isPendingProjectCreateFieldEditMessage(msg: ChatMessage): boolean {
  const p = getProjectCreateFieldEditFromMessage(msg);
  return Boolean(p && p.status === 'pending');
}

export function projectCreateFieldEditDoneLabel(msg: ChatMessage): string {
  const p = getProjectCreateFieldEditFromMessage(msg);
  if (!p || p.status === 'pending') return '';
  return p.status === 'accepted' ? '已将改写应用到左侧表单' : '已放弃本次改写建议';
}
